import * as React from 'react';
import PageMain from '../../components/Navigation/PageMain/PageMain';
import ClientViews from '../../components/Settings/ClientViews/ClientViews';
import { useClientFields } from '../../sic-lib/api/hooks/useClientFields';
import { useGetViews } from '../../sic-lib/api/hooks/useViews';

export default function CustomViewsPage() {
    /*
        TIP: Requests for page dependancies which should resolve before page
        children are rendered
     */
    const { isLoading, isError } = useClientFields();

    const { data: viewsData, isLoading: isViewLoading, isError: isViewError } = useGetViews();

    const views = React.useMemo(() => {
        return viewsData || [];
    }, [viewsData]);

    return (
        <PageMain
            pageTitle="Custom views"
            showError={isViewError || isError}
            showLoading={isViewLoading || isLoading}
        >
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <ClientViews views={views} />
                </div>
            </div>
        </PageMain>
    );
}
